import { render, staticRenderFns } from "./personnelEditModel.vue?vue&type=template&id=3bd87f85&scoped=true"
import script from "./personnelEditModel.vue?vue&type=script&lang=js"
export * from "./personnelEditModel.vue?vue&type=script&lang=js"
import style0 from "./personnelEditModel.vue?vue&type=style&index=0&id=3bd87f85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd87f85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd87f85')) {
      api.createRecord('3bd87f85', component.options)
    } else {
      api.reload('3bd87f85', component.options)
    }
    module.hot.accept("./personnelEditModel.vue?vue&type=template&id=3bd87f85&scoped=true", function () {
      api.rerender('3bd87f85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/personnelDetail/personnelEditModel.vue"
export default component.exports